// Retries idempotent calls to our own API that got no response at all: a
// network blip, or the backend restarting during a deploy (the service mounts a
// volume, so Railway stops the old container before the new one answers). The
// sign-up page fires four such GETs on load; without a retry a deploy shows a
// broken page to whoever opens it at that second. POST/PUT/DELETE are never
// replayed, and any HTTP response (4xx/5xx) is passed through untouched.

export const RETRY_DELAYS_MS = [1000, 3000];

export function shouldRetry(error, apiBase) {
  if (!error || error.response) return false;
  const config = error.config;
  if (!config || (config.__retryCount || 0) >= RETRY_DELAYS_MS.length) return false;
  if (error.code === 'ERR_CANCELED' || error.name === 'CanceledError') return false;
  const method = String(config.method || 'get').toLowerCase();
  if (method !== 'get' && method !== 'head') return false;
  const url = String(config.url || '');
  return url.startsWith(apiBase) || url.startsWith('/api');
}

export function installNetworkRetry(axiosInstance, options = {}) {
  const { apiBase, sleep } = options;
  if (!axiosInstance || !axiosInstance.interceptors || !apiBase) return false;
  const wait = sleep || ((ms) => new Promise((resolve) => setTimeout(resolve, ms)));
  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (!shouldRetry(error, apiBase)) throw error;
      const config = error.config;
      config.__retryCount = (config.__retryCount || 0) + 1;
      await wait(RETRY_DELAYS_MS[config.__retryCount - 1]);
      return axiosInstance.request(config);
    }
  );
  return true;
}
